import type {
  Invitation,
  UpdatePasswordBody,
  UpdateProfileBody,
  User,
  UserSearchParams,
} from '@/domain/user';
import { crudService } from '@/services/apiClient';
import LookupService from '@/services/lookup';
import { api } from '@/utils/configuration';
import type { GenericAbortSignal } from 'axios';
import type { Operation } from 'fast-json-patch';

export const UserService = {
  search: (params: UserSearchParams, signal?: GenericAbortSignal) =>
    crudService.get<User[]>(api.USER_URL, { params, signal }),

  lookup: LookupService.user,

  inviteUsers: (invitations: Invitation[]) => crudService.post<void>({ invitations }, api.USER_URL),

  me: (signal?: GenericAbortSignal) => crudService.get<User>(`${api.USER_URL}/me`, { signal }),

  updateMe: (body: UpdateProfileBody) => crudService.put<User>(body, `${api.USER_URL}/me`),

  changePassword: (body: UpdatePasswordBody) =>
    crudService.put<void>(body, `${api.USER_URL}/me/password`),

  findById: (id: number, signal?: GenericAbortSignal) =>
    crudService.get<User>(`${api.USER_URL}/${id}`, { signal }),

  patch: (id: number, operations: Operation[], version: number) =>
    crudService.patch<void>(operations, `${api.USER_URL}/${id}?version=${version}`),

  delete: (id: number) => crudService.delete<void>(`${api.USER_URL}/${id}`),

  invite: (id: number) => crudService.post<void>({}, `${api.USER_URL}/${id}/invite`),
};
